import type { ButtonHTMLAttributes, FC } from "react";
import React, { useState } from "react";
import { Button } from "react-bootstrap";

import type { IApplication } from "../../../../hooks/reactQueryHooks/useApplications";
import { AddCacheItemForm } from "../forms/AddCacheItem";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  applications: Array<IApplication>;
}

const AddCacheItem: React.FC<ButtonProps> = ({ applications }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false);
  };

  const handleOpen = () => {
    setShow(true);
  };

  return (
    <>
      {show && (
        <AddCacheItemForm onCancel={handleClose} applications={applications} />
      )}
      <Button onClick={handleOpen} className="fw-bold flex-shrink-0 ms-5">
        + Add cache item(s)
      </Button>
    </>
  );
};

export { AddCacheItem };
